import React from 'react';
import TableHead from "./TableHead";
import AttributeRow from "./AttributeRow";
import TableFoot from "./TableFoot";
import ScoresRow from "./ScoresRow";
import PricingRow from "./PricingRow";
import PromosRow from "./PromosRow";
import FitRow from "./FitRow";
import InstallTimeRow from "./InstallTimeRow";
import {useThemeVar} from "../Utility/siteConfig";
import clsx from "clsx";
import PropTypes from "prop-types";

export default function CompareItemsTable({
  items,
  attributes,
  allValues = {},
  compatibility = {},
  vehicle = {},
  allScores = {},
  hideItem
}) {
  const siteName = useThemeVar('siteName');

  const toolSite = (siteName === 'carlyle');

  let classes = ['compare-items', 'product-grid'];

  return (
    <table id="compare-items-table" className={clsx(classes)}>
      <TableHead
        items={items}
        hideItem={hideItem}/>

      <tbody>
        <PricingRow items={items}/>

        <PromosRow items={items}/>

        <ScoresRow
          items={items}
          allScores={allScores}/>

        {!toolSite && <InstallTimeRow items={items} allScores={allScores}/>}

        {!toolSite && <FitRow items={items}
          compatibility={compatibility}
          vehicle={vehicle}/>}

        {attributes.map((a, i) =>
          <AttributeRow attribute={a} items={items} key={a.name || i}
          values={allValues[a.id]}/>)}
      </tbody>

      <TableFoot items={items} hideItem={hideItem}/>
    </table>);

}

CompareItemsTable.propTypes = {
  items: PropTypes.array.isRequired,
  attributes: PropTypes.object.isRequired,
  allValues: PropTypes.object.isRequired,
  compatibility: PropTypes.object.isRequired,
  vehicle: PropTypes.object,
  allScores: PropTypes.object.isRequired,
  hideItem: PropTypes.func.isRequired
}
